import React from 'react';
import { render } from 'react-dom';
import { Provider } from 'react-redux';
import { BrowserRouter as Router } from 'react-router-dom';
import 'react-rangeslider/lib/index.css';

import createStore from './store/store';
import Setup from './Setup';
import '../css/main.critical.css';
import '../css/main.css';

async function renderApp() {
  const store = await createStore();
  render(
    <Provider store={store}>
      <Router>
        <Setup />
      </Router>
    </Provider>,
    document.getElementById('app'),
  );
}

export default renderApp;



// WEBPACK FOOTER //
// ./src/js/renderApp.js